import dayjs from 'dayjs';
import useUserLanguage from '/business/shared/hooks/useUserLanguage';

// We are requiring relevant locales here so they are available when calling dayjs.locale()
import 'dayjs/locale/en';
import 'dayjs/locale/zh';

export default function useTranslatedDate({
  date,
  format = 'MMM YYYY',
}: {
  date: string | number | Date | null | undefined;
  format?: string;
}): string {
  const userLanguage = useUserLanguage();
  dayjs.locale(userLanguage);
  const translatedDate = dayjs(date).format(format);
  return translatedDate;
}
